'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _reactRouter = require('react-router');

var _data = require('../../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
    var resolver = this;

    if (catcher === true) {
        if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
            var _tasks = [];

            if (!tick) {
                try {
                    tick = process.nextTick;
                } catch (ex) {
                    tick = function tick(p) {
                        setTimeout(p, 0);
                    };
                }
            }

            function _untask() {
                for (var i = 0; i < _tasks.length; i += 2) {
                    var t = _tasks[i + 1],
                        r = _tasks[i];

                    for (var j = 0; j < t.length; j++) {
                        t[j].call(null, r);
                    }
                }

                _tasks = [];
            }

            function isThenable(obj) {
                return obj && obj instanceof Object && typeof obj.then === 'function';
            }

            function EagerThenable(resolver) {
                function done(inline) {
                    var w;
                    if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

                    _tasks.push(result, w);

                    _thens = [[], []];
                    if (_tasks.length === 2) inline ? _untask() : tick(_untask);
                }

                function resolveThen(x) {
                    if (isThenable(x)) return x.then(resolveThen, rejectThen);
                    phase = 0;
                    result = x;
                    done(true);
                }

                function rejectThen(x) {
                    if (isThenable(x)) return x.then(resolveThen, rejectThen);
                    phase = 1;
                    result = x;
                    done(true);
                }

                function settler(resolver, rejecter) {
                    _thens[0].push(resolver);

                    _thens[1].push(rejecter);

                    done();
                }

                function toString() {
                    return 'EagerThenable{' + {
                        '-1': 'pending',
                        0: 'resolved',
                        1: 'rejected'
                    }[phase] + '}=' + result.toString();
                }

                this.then = settler;
                this.toString = toString;
                var _thens = [[], []],
                    _sync = true,
                    phase = -1,
                    result;
                resolver.call(null, resolveThen, rejectThen);
                _sync = false;
                done();
            }

            EagerThenable.resolve = function (v) {
                return isThenable(v) ? v : {
                    then: function then(resolve, reject) {
                        return resolve(v);
                    }
                };
            };

            return EagerThenable;
        }();
        return new Function.prototype.$asyncbind.EagerThenable(boundThen);
    }

    if (catcher) {
        if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
        return then;
    }

    function then(result, error) {
        try {
            return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
        } catch (ex) {
            return (error || catcher)(ex);
        }
    }

    function boundThen(result, error) {
        return resolver.call(self, result, error);
    }

    boundThen.then = boundThen;
    return boundThen;
};

var React = require('react');
var _ = require('lodash-compat');


var NODE = "node";
var FOLDER = "folder";
var MODEL = {
    "idField": "code",
    "showField": "label",
    "typeField": "type",
    "childrenField": "children"
};

/**
 * 查找folder下第一个是type是node的子节点返回
 */
function findRedirectNode(folder) {
    var node = null,
        list = folder[MODEL.childrenField];
    if (list && list.length > 0) {
        for (var i = 0; i < list.length; i++) {
            if (list[i][MODEL.typeField] == NODE) {
                node = list[i];
                break;
            } else if (list[i][MODEL.typeField] == FOLDER) {
                node = findRedirectNode(list[i]);
                if (node) {
                    break;
                }
            }
        }
    }
    return node;
}
/**
 * parse一个节点装载到routes中
 * @param node 需要解析的一个菜单model
 * @param routesMap menu与Component配置的映射
 * @param paths 所有绑定到Component的path的集合
 * @param customRoutes 自定义的routes的集合
 * @return 返回一个对象
 * {
 *          code:"console",
 *          path:"/console",
 *          redirect:"/post-review",
 *          children:[
 *              {
 *                  code:"post-review",
 *                  path:"/post-review",
 *                  component:Component
 *              },
 *              {
 *                  code:"post-list",
 *                  path:"/post-list",
 *                  component:Component,
 *                  custom:[
 *                      path:"/post-list/:id"
 *                  ]
 *              }
 *          ]
 *      }
 */
function fillRoute(node, routesMap, paths, customRoutes) {
    var route = void 0,
        customList = routesMap.custom || [];
    if (node[MODEL.typeField] == NODE) {
        var _route2;

        //生成node
        route = (_route2 = {}, _defineProperty(_route2, MODEL.idField, node[MODEL.idField]), _defineProperty(_route2, 'path', "/" + node[MODEL.idField]), _defineProperty(_route2, 'component', routesMap[node[MODEL.idField]]), _route2);
        //填充path
        paths.push(_defineProperty({ path: route.path }, MODEL.idField, route[MODEL.idField]));
        //填充自定义
        _.forEach(customList, function (child) {
            if (child[MODEL.idField] == route[MODEL.idField]) {
                var _customRoutes$push;

                customRoutes.push((_customRoutes$push = {}, _defineProperty(_customRoutes$push, MODEL.idField, child[MODEL.idField]), _defineProperty(_customRoutes$push, 'path', child.path.substring(0, 1) != "/" ? "/" + child.path : child.path), _defineProperty(_customRoutes$push, 'component', child.component), _customRoutes$push));
                paths.push(_defineProperty({
                    path: child.path.substring(0, 1) != "/" ? "/" + child.path : child.path
                }, MODEL.idField, route[MODEL.idField]));
            }
        });
    } else if (node[MODEL.typeField] == FOLDER) {
        //生成route 包含redirect 默认重定向到第一个是node的下级子节点
        var redirectNode = findRedirectNode(node);
        if (redirectNode) {
            (function () {
                var _route3;

                route = (_route3 = {}, _defineProperty(_route3, MODEL.idField, node[MODEL.idField]), _defineProperty(_route3, 'path', "/" + node[MODEL.idField]), _defineProperty(_route3, 'redirect', "/" + redirectNode[MODEL.idField]), _route3);
                if (routesMap[node[MODEL.idField]]) {
                    route.component = routesMap[node[MODEL.idField]];
                }
                //遍历子节点填充
                var children = node[MODEL.childrenField],
                    childRoute = void 0;
                children && _.forEach(children, function (childNode) {
                    if (childNode[MODEL.typeField] == NODE || childNode[MODEL.typeField] == FOLDER) {
                        childRoute = fillRoute(childNode, routesMap, paths, customRoutes);
                        if (!route[MODEL.childrenField]) {
                            route[MODEL.childrenField] = [];
                        }
                        route[MODEL.childrenField].push(childRoute);
                    }
                });
            })();
        } else {
            var _route4;

            route = (_route4 = {}, _defineProperty(_route4, MODEL.idField, node[MODEL.idField]), _defineProperty(_route4, 'path', "/" + node[MODEL.idField]), _route4);
            if (routesMap[node[[MODEL.idField]]]) {
                route.component = routesMap[node[MODEL.idField]];
            }
        }
    }
    return route;
}

/**
 * parse一个重定向节点装载到routes中
 * @param routesMap menu与Component配置的映射
 * @param paths 所有绑定到Component的path的集合
 * @param redirectRoutes 重定向 routes 的集合
 */
function fillRedirectRoute(routesMap, paths, redirectRoutes) {
    var redirectList = routesMap.redirect || [];
    _.forEach(redirectList, function (child) {
        var _redirectRoutes$push, _paths$push3;

        var from = child.from.startsWith('/') ? child.from : '/' + child.from;
        var to = child.to.startsWith('/') ? child.to : '/' + child.to;
        redirectRoutes.push((_redirectRoutes$push = {}, _defineProperty(_redirectRoutes$push, MODEL.idField, from), _defineProperty(_redirectRoutes$push, 'path', from), _defineProperty(_redirectRoutes$push, 'redirect', to), _redirectRoutes$push));
        paths.push((_paths$push3 = {}, _defineProperty(_paths$push3, MODEL.idField, from), _defineProperty(_paths$push3, 'path', from), _defineProperty(_paths$push3, 'redirect', to), _paths$push3));
    });
}

/**
 * 递归生成route
 */
function renderRoute(route, rootRoutes, pathMap) {
    var _route = {};
    if (route[MODEL.childrenField] && route[MODEL.childrenField].length > 0) {
        if (route.redirect) {
            var _route5;

            _route = (_route5 = {}, _defineProperty(_route5, MODEL.idField, route[MODEL.idField]), _defineProperty(_route5, 'path', parsePath(route.path, pathMap)), _defineProperty(_route5, 'childRoutes', []), _route5);
            if (route.component) {
                if (isResumeComponent(route.component)) {
                    _route.getComponent = toComponent(route.component);
                } else {
                    _route.component = route.component;
                }
            }
            rootRoutes.push((0, _reactRouter.createRoutes)(React.createElement(_reactRouter.Redirect, { from: parsePath(route.path, pathMap),
                to: parsePath(route.redirect, pathMap) }))[0]);
            _.forEach(route[MODEL.childrenField], function (childRoute) {
                _route.childRoutes.push(renderRoute(childRoute, rootRoutes, pathMap));
            });
            return _route;
        } else {
            var _route6;

            _route = (_route6 = {}, _defineProperty(_route6, MODEL.idField, route[MODEL.idField]), _defineProperty(_route6, 'path', parsePath(route.path, pathMap)), _defineProperty(_route6, 'childRoutes', []), _route6);
            if (route.component) {
                if (isResumeComponent(route.component)) {
                    _route.getComponent = toComponent(route.component);
                } else {
                    _route.component = route.component;
                }
            }
            _.forEach(route[MODEL.childrenField], function (childRoute) {
                _route.childRoutes.push(renderRoute(childRoute, rootRoutes, pathMap));
            });
            return _route;
        }
    } else {
        var _route9;

        if (route.redirect) {
            if (route.component) {
                var _route7;

                _route = (_route7 = {}, _defineProperty(_route7, MODEL.idField, route[MODEL.idField]), _defineProperty(_route7, 'path', parsePath(route.path, pathMap)), _route7);
                if (isResumeComponent(route.component)) {
                    _route.getComponent = toComponent(route.component);
                } else {
                    _route.component = route.component;
                }
            } else {
                var _route8;

                _route = (_route8 = {}, _defineProperty(_route8, MODEL.idField, route[MODEL.idField]), _defineProperty(_route8, 'path', parsePath(route.path, pathMap)), _route8);
            }
            _route.childRoutes = [];
            rootRoutes.push((0, _reactRouter.createRoutes)(React.createElement(_reactRouter.Redirect, { from: parsePath(route.path, pathMap),
                to: parsePath(route.redirect, pathMap) }))[0]);
        }
        _route = (_route9 = {}, _defineProperty(_route9, MODEL.idField, route[MODEL.idField]), _defineProperty(_route9, 'path', parsePath(route.path, pathMap)), _route9);
        if (route.component) {
            if (isResumeComponent(route.component)) {
                _route.getComponent = toComponent(route.component);
            } else {
                _route.component = route.component;
            }
        }
        return _route;
    }
}
/**
 * 转换为需要的component
 */
function toComponent(component) {
    return function (state, callback) {
        //TODO 需要加进度条
        component().then(function (x) {
            callback(null, x);
        });
    };
}
/**
 * 是否是异步加载的component
 */
function isResumeComponent(component) {
    //如果有prototype 并且有render方法 则表示是react对象
    if (component && component.prototype && component.prototype.render) {
        return false;
    }
    return true;
}
/**
 * 查找某个 idField 对应的配置
 * @param idField
 * @param menu
 * @return 返回一个对象
 * {
 *  node: {} 节点
 *  top: true|false 是否是顶层节点
 * }
 */
function findNode(idField, menu) {
    if (idField && menu && menu.length > 0) {
        var _ret2 = function () {
            var result = void 0,
                top = void 0;
            var find = function find(folder, isTop) {
                (folder || []).forEach(function (node) {
                    if (node[MODEL.idField] === idField) {
                        result = node;
                        top = isTop;
                        return;
                    } else if (node[MODEL.typeField] === FOLDER) {
                        find(node[MODEL.childrenField]);
                    }
                });
            };
            find(menu, true);
            return {
                v: { node: result, top: top }
            };
        }();

        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    }
}

/**
 * 从pathMap中parse path
 */
function parsePath(path, pathMap) {
    var _path = path,
        _subpath = '';
    if (path.indexOf('/') == 0) {
        var source = path.substring(1, path.length);
        var index = source.indexOf('/');
        if (index === -1) {
            path = source;
        } else {
            path = source.substring(0, index);
            _subpath = source.substring(index, source.length);
        }
    }

    if (pathMap && !(0, _data.isEmptyString)(pathMap[path])) {
        _path = pathMap[path];
    } else {
        _path = path;
    }
    if (_path.substring(0, 1) != "/") {
        _path = "/" + _path;
    }
    return _path + _subpath;
}
/**
 * 判断是否 url 与 route 的 path 相符
 * 通配符的规则如下。
 * :paramName 匹配URL的一个部分，直到遇到下一个/、?、#为止。这个路径参数可以通过this.props.params.paramName取出。
 * () 表示URL的这个部分是可选的。
 * * 匹配任意字符，直到模式里面的下一个字符为止。匹配方式是非贪婪模式。
 * ** 匹配任意字符，直到下一个/、?、#为止。匹配方式是贪婪模式。
 */
// <Route path="/hello/:name">         // matches /hello/michael and /hello/ryan
// <Route path="/hello(/:name)">       // matches /hello, /hello/michael, and /hello/ryan
// <Route path="/files/*.*">           // matches /files/hello.jpg and /files/hello.html
// <Route path="/**/*.jpg">            // matches /files/hello.jpg and /files/path/to/file.jpg
function isMatchRoute(pathname, path) {
    if (!pathname.startsWith('/')) {
        pathname = '/' + pathname;
    }
    var regexp = path.replace(/\(([^\)]+)\)/g, '($1)?').replace(/:[^\/\?#\(\)]+/g, '[^/?#()]+').replace(/\*\*/g, '.+').replace(/\*([^*])/g, '[^$1]+$1');
    return new RegExp('^' + regexp + '$', 'g').test(pathname.replace(/(#|\?).*/, ''));
}

/**
 * 页面的主要内容
 * 接收四个参数
 * props.topRoutes 顶级路由与组件的映射
 * props.routes  层级菜单路由与组件的映射
 * props.menu    菜单树
 * props.history 路由的history对象
 * props.noFoundComponent 路由没有时的错误页面
 */
var Page = (0, _createReactClass2.default)({

    getDefaultProps: function getDefaultProps() {
        return {
            showDefaultPath: true
        };
    },
    getInitialState: function getInitialState() {
        var _this = this;

        if ('pathMap' in this.props) {
            console.warn('pathMap 属性将被废弃, 请使用 getPathMap');
        }
        var _props = this.props;
        var App = _props.app;
        var menuModel = _props.menuModel;

        Object.assign(MODEL, menuModel);
        this.content = function (rootProps) {
            var props = {};
            props.selected = _this.selected;
            props.pathMap = _this.pathMap;
            return React.createElement(App, _extends({ menu: _this.menu }, props, rootProps, { menuModel: MODEL }));
        };
        return {};
    },

    /**
     * @return
     * {
     *  topRoutes:[{path:"/home",component:Component}],
     *  routes:[
     *      {
     *          code:"console",
     *          path:"/console",
     *          redirect:"/post-review",
     *          children:[
     *              {
     *                  code:"post-review",
     *                  path:"/post-review",
     *                  component:Component
     *              },
     *              {
     *                  code:"post-list",
     *                  path:"/post-list",
     *                  component:Component,
     *                  custom:[
     *                      path:"/post-list/:id"
     *                  ]
     *              }
     *          ]
     *      }
     *  ],
     *  paths:[{"path":"/post-list","selected":"post-list"},{"path:"/post-list/:id","selected":"post-list"}]
     * }
     */
    createRouter: function createRouter(_menu, routesMap, _topRoutes, nextState) {
        var router = {
            routes: [],
            paths: []
        },
            hasInitPath = false;
        _topRoutes && _.forEach(_topRoutes, function (topRoute) {
            //是不是以/开头的
            var path = topRoute['path'];
            if (path == "/") {
                hasInitPath = true;
            }
        });
        var initRedirectNode = void 0,
            isTopPath = false;
        if (!hasInitPath) {
            var getEntryNode = this.props.getEntryNode;

            if (getEntryNode && _.isFunction(getEntryNode)) {
                getEntryNode(nextState.location, _menu, function (idField) {
                    // add by liukaimei 170922, 判断返回的节点是否有效, 是否是顶层的节点

                    var _ref = findNode(idField, _menu) || {};

                    var _ref$node = _ref.node;
                    var node = _ref$node === undefined ? {} : _ref$node;
                    var top = _ref.top;

                    if (node[MODEL.typeField] === NODE) {
                        initRedirectNode = node;
                        isTopPath = top;
                    } else if (node[MODEL.typeField] === FOLDER) {
                        initRedirectNode = findRedirectNode(node);
                    }
                });
            }
            if (!initRedirectNode) {
                for (var i = 0; i < _menu.length; i++) {
                    if (_menu[i][MODEL.typeField] === NODE) {
                        initRedirectNode = _menu[i];
                        isTopPath = true;
                        break;
                    } else if (_menu[i][MODEL.typeField] === FOLDER) {
                        initRedirectNode = findRedirectNode(_menu[i]);
                        if (initRedirectNode) break;
                    }
                }
            }
            if (initRedirectNode) {
                if (this.props.showDefaultPath && isTopPath) {
                    router.indexRoute = _defineProperty({
                        path: "/",
                        component: routesMap[initRedirectNode[MODEL.idField]]
                    }, MODEL.idField, initRedirectNode[MODEL.idField]);
                } else {
                    var pathMap = this.getPathMap();
                    router.indexRoute = {
                        path: "/",
                        redirect: pathMap[initRedirectNode[MODEL.idField]] || '/' + initRedirectNode[MODEL.idField],
                        component: routesMap[initRedirectNode[MODEL.idField]]
                    };
                }
            }
        }
        var self = this,
            customRoutes = [],
            redirectRoutes = [];
        _menu && _.forEach(_menu, function (node) {
            if (!(self.props.showDefaultPath && router.indexRoute && router.indexRoute[MODEL.idField] == node[MODEL.idField])) {
                if (node[MODEL.typeField] == NODE || node[MODEL.typeField] == FOLDER) {
                    router.routes.push(fillRoute(node, routesMap, router.paths, customRoutes));
                }
            }
        });
        fillRedirectRoute(routesMap, router.paths, redirectRoutes);
        _.forEach(customRoutes, function (customRoute) {
            router.routes.push(customRoute);
        });
        _.forEach(redirectRoutes, function (redirectRoute) {
            router.routes.push(redirectRoute);
        });
        return router;
    },


    // 根据数据渲染Router树
    render: function render() {
        var routes = {
            getChildRoutes: this.getChildRoutes
        };
        return React.createElement(
            _reactRouter.Router,
            { history: this.props.history },
            routes
        );
    },
    /**
     * 获得当前路由匹配到对应选中的menu code
     */
    getSelected: function getSelected(location) {
        var paths = location.pathname.split("/"),
            selected = "",
            pathMap = this.getPathMap();
        // add by liukaimei 171027, 有可能是 props.pathMap 直接传入的, 需要优先处理相等的, 其次对于 custom 定义的使用父code
        selected = (Object.keys(pathMap) || []).find(function (prop) {
            return location.pathname === pathMap[prop];
        });
        if (!selected) {
            // 父节点被 pathMap 了
            (Object.keys(pathMap) || []).forEach(function (prop) {
                if (location.pathname.startsWith(pathMap[prop]) && (!selected || selected.length < prop.length)) {
                    selected = prop;
                }
            });
        }
        if (selected) {
            return selected;
        }
        var index = this.router.routes.findIndex(function (v) {
            return isMatchRoute(location.pathname, v.path);
        });
        if (index !== -1) {
            // add by liukaimei 180903, 如果是 custom 设置，应选中正确的父节点。
            return this.router.routes[index][MODEL.idField];
        }

        if (paths.length > 1) {
            // 没有经过 pathMap 配置
            selected = paths[1];
        }
        if (this.props.showDefaultPath) {
            if (location.pathname === "/" || location.pathname === "") {
                if (this.indexRoute && this.indexRoute[MODEL.idField]) {
                    selected = this.indexRoute[MODEL.idField];
                }
            }
        }
        return selected;
    },
    getPathMap: function getPathMap() {
        var _this2 = this;

        var _props2 = this.props;
        var showDefaultPath = _props2.showDefaultPath;
        var getPathMap = _props2.getPathMap;

        var pathMap = {};
        if (getPathMap && _.isFunction(getPathMap)) {
            (function () {
                // add by liukaimei 170922, 遍历每个node型节点, 如果返回为string, 则设置添加映射关系
                var find = function find(menu) {
                    (menu || []).forEach(function (node) {
                        if (node[MODEL.typeField] === NODE) {
                            getPathMap(node, _this2.menu, function (res) {
                                if (res && typeof res === 'string') {
                                    pathMap[node[MODEL.idField]] = res.startsWith('/') ? res : '/' + res;
                                }
                            });
                        } else if (node[MODEL.typeField] === FOLDER) {
                            find(node[MODEL.childrenField]);
                        }
                    });
                };
                find(_this2.menu);
            })();
        } else if ('pathMap' in this.props) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.entries(this.props.pathMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _step$value = _slicedToArray(_step.value, 2);

                    var prop = _step$value[0];
                    var value = _step$value[1];

                    pathMap[prop.startsWith('/') ? prop.slice(1) : prop] = value.startsWith('/') ? value : '/' + value;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        this.pathMap = _.clone(pathMap);
        if (showDefaultPath) {
            if (this.indexRoute && this.indexRoute[MODEL.idField]) {
                this.pathMap[this.indexRoute[MODEL.idField]] = "/";
            }
        }
        return pathMap;
    },
    getComponent: function getComponent(nextState, cb) {
        var _this3 = this;

        //获取menu 获取selected
        this.props.fetchMenu(nextState.location, function (menu) {
            _this3.menu = menu;
            _this3.selected = _this3.getSelected(nextState.location);
            cb(null, _this3.content);
        });
    },
    getChildRoutes: function getChildRoutes(nextState, cb) {
        var _this4 = this;

        var topRoutes = this.props.topRoutes;var routes = [];
        //FIXME 区分component或getComponent 用于处理异步加载
        topRoutes && _.forEach(topRoutes, function (topRoute) {
            var path = topRoute['path'],
                _route = void 0;
            if (path == "/") {
                _route = { path: "/", indexRoute: {} };
                if (topRoute.component) {
                    if (isResumeComponent(topRoute.component)) {
                        _route.indexRoute.getComponent = toComponent(topRoute.component);
                    } else {
                        _route.indexRoute.component = topRoute.component;
                    }
                }
                routes.push(_route);
            } else {
                if (path.substring(0, 1) != "/") {
                    path = "/" + path;
                }
                _route = { path: path };
                if (topRoute.component) {
                    if (isResumeComponent(topRoute.component)) {
                        _route.getComponent = toComponent(topRoute.component);
                    } else {
                        _route.component = topRoute.component;
                    }
                }
                routes.push(_route);
            }
        });
        //构建App 根route
        //routes.push(createRoutes(<Route path="" getComponent={this.getComponent} getChildRoutes={this.getAppChildRoutes}/>)[0]);
        this.props.fetchMenu(nextState.location, function (menu) {
            if (menu == _this4.menu) {
                routes.push(_this4.rootRoute);
            } else {
                _this4.menu = menu;
                var router = _this4.createRouter(menu, _this4.props.routes, _this4.props.topRoutes, nextState);
                _this4.router = router;
                _this4.rootRoute = {
                    getComponent: _this4.getComponent,
                    getChildRoutes: _this4.getAppChildRoutes
                };
                if (router.indexRoute) {
                    _this4.indexRoute = router.indexRoute;
                    if (router.indexRoute.redirect) {
                        routes.push((0, _reactRouter.createRoutes)(React.createElement(_reactRouter.Redirect, { from: '/', to: router.indexRoute.redirect }))[0]);
                    } else {
                        _this4.rootRoute.path = "/";
                        if (router.indexRoute.component) {
                            if (isResumeComponent(router.indexRoute.component)) {
                                _this4.rootRoute.indexRoute = { getComponent: toComponent(router.indexRoute.component) };
                            } else {
                                _this4.rootRoute.indexRoute = { component: router.indexRoute.component };
                            }
                        }
                    }
                }
                routes.push(_this4.rootRoute);
            }
            cb(null, routes);
        });
    },
    getAppChildRoutes: function getAppChildRoutes(nextState, cb) {
        var routes = [],
            rootRoutes = [],
            pathMap = this.getPathMap(),
            _route = void 0;
        _.forEach(this.router.routes, function (route) {
            if (route.path == "/" && route.redirect) {
                if (route.component) {
                    var _route10;

                    _route = (_route10 = {}, _defineProperty(_route10, MODEL.idField, route[MODEL.idField]), _defineProperty(_route10, 'path', parsePath(route.path, pathMap)), _route10);
                    if (route.component) {
                        if (isResumeComponent(route.component)) {
                            _route.getComponent = toComponent(route.component);
                        } else {
                            _route.component = route.component;
                        }
                    }
                    routes.push(_route);
                    routes.push((0, _reactRouter.createRoutes)(React.createElement(_reactRouter.Redirect, { form: parsePath(route.path, pathMap),
                        to: parsePath(route.redirect, pathMap) }))[0]);
                } else {
                    var _routes$push;

                    routes.push((_routes$push = {}, _defineProperty(_routes$push, MODEL.idField, route[MODEL.idField]), _defineProperty(_routes$push, 'path', parsePath(route.path, pathMap)), _routes$push));
                    routes.push((0, _reactRouter.createRoutes)(React.createElement(_reactRouter.Redirect, { form: parsePath(route.path, pathMap),
                        to: parsePath(route.redirect, pathMap) }))[0]);
                }
            } else {
                routes.push(renderRoute(route, rootRoutes, pathMap));
            }
        });
        _.forEach(routes, function (route) {
            rootRoutes.push(route);
        });
        if (this.props.noPermissionComponent) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(this.props.routes)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var k = _step2.value;

                    if (k !== 'custom') {
                        rootRoutes.push({
                            path: '/' + k,
                            component: this.props.noPermissionComponent
                        });
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (this.props.routes.custom != null) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = this.props.routes.custom[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var r = _step3.value;

                        rootRoutes.push({
                            path: r.path,
                            component: this.props.noPermissionComponent
                        });
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        }
        if (this.props.noFoundComponent) {
            rootRoutes.push({ path: "*", component: this.props.noFoundComponent });
        }
        cb(null, rootRoutes);
    }
});
exports.default = Page;